import { Form } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useColumnsProviderCalculation } from "../hooks/useColumnsProviderCalculation";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import { GetSimulationContext } from "../hooks/useSimulation";

const ProviderStatusTable = ({ isLoading, providerSimulations, providerEquivalency }) => {
    const dispatch = useDispatch();
    const [simulations, setSimulations] = useState([]);
    const { updateProject } = GetSimulationContext();

    const {
        columns: columnsProviderCalculation,
        props: propsProviderCalculation,
        formProviderCalculation,
    } = useColumnsProviderCalculation(dispatch, updateProject);

    useEffect(() => {
        const { hourDLL, hourMX } = providerEquivalency;

        setSimulations(
            providerSimulations
                .map((provider, index) => {
                    if (provider.type !== "B") return null;
                    const { projectId, name, areaUserId, currency, link, status, outsourceHours, budget, providerHours, type, areaName } = provider;
                    const equivalencyHrs = currency === "MXN" ? hourMX.$numberDecimal : hourDLL.$numberDecimal;
                    const realmoney = equivalencyHrs * outsourceHours;
                    const budgetInit = parseFloat(realmoney * 0.75);
                    const budgetMax = parseFloat(realmoney * 1.1);

                    return {
                        indexData: index,
                        key: provider._id,
                        _id: provider._id,
                        projectId,
                        name,
                        areaUserId,
                        currency,
                        link,
                        status,
                        outsourceHours,
                        budget,
                        providerHours,
                        type,
                        area: areaName,
                        realmoney,
                        budgetInit,
                        budgetMax,
                        // }
                    };
                })
                .filter((provider) => provider !== null)
        );
    }, [providerEquivalency, providerSimulations]);
    return (
        <div className="w-full">
            <Form form={formProviderCalculation} component={false}>
                <TableGeneral
                    loading={isLoading}
                    state={simulations}
                    column={columnsProviderCalculation}
                    tableProps={propsProviderCalculation}
                    pagination={{ position: ["bottomRight", "bottomRight"], pageSize: 3 }}
                />
            </Form>
        </div>
    );
};

export default ProviderStatusTable;
